
let count = 0
let timer = []
const DELAY = 0
export function clear() {
  timer.forEach(row => {
    clearTimeout(row)
  })
  timer = []
  count = 0
}
export function showDelay(delay) {
  count++
  if (!delay) {
    delay = DELAY
  }
  show()
  count--
}
export function hideDelay(delay) {
  count--
  if (!delay) {
    delay = DELAY
  }
  setTimeout(() => {
    count++
    hide()
  }, delay)
}
export function show() {
  count++
  if (count > 0) {
    // Toast.loading({
    //   message: 'toast.loading1',
    //   forbidClick: true,
    //   duration: 30 * 1000
    // })
  }
}
export function hide() {
  count--
  if (count < 1) {
    // Toast.clear()
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js